__turbopack_context__.v({
  "className": "dm_sans_71a0bd08-module__t2fx-a__className",
  "variable": "dm_sans_71a0bd08-module__t2fx-a__variable",
});
